module.exports = __webpack_public_path__ + "img/money-bill-simple.629a7e99.svg";